import { useLayoutEffect } from 'react';

import liveSessioner from '../livesession/LiveSessioner';
import videoChatControllerIframeService from './VideoChatControllerIframeService';

function useVideoChatController(frameSrc) {
    /**
     * iframe may load very fast, but stopStream and addReadyListener must
     * happen before load, so it's better use useLayoutEffect.
     */
    useLayoutEffect(() => {
        if (videoChatControllerIframeService.isStreamStopNeeded(frameSrc)) {
            liveSessioner.stopStream();
        }
    }, [frameSrc]);

    useLayoutEffect(() => {
        videoChatControllerIframeService.addReadyListener();

        return () => {
            videoChatControllerIframeService.removeReadyListener();
        };
    }, []);
}

export default useVideoChatController;
